import classNames from 'classnames';
import { ForwardedRef } from 'react';

import BasicButton, { BasicButtonElement, BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/rounded-button.module.css';

export interface RoundedButtonProps extends BasicButtonProps {
    compact?: boolean;
    transparent?: boolean;
    active?: boolean;
    activeClassName?: string | null;
}

function RoundedButton({
    transparent = false,
    compact = false,
    active = false,
    className = null,
    activeClassName = null,
    ref: buttonRef = null,
    ...props
}: RoundedButtonProps & { ref?: ForwardedRef<BasicButtonElement> | null }) {
    return (
        <BasicButton
            className={classNames([
                styles.container,
                {
                    [styles.transparent]: transparent,
                    [styles.compact]: compact,
                    [styles.active]: active,
                    [activeClassName]: active && activeClassName !== null,
                },
                className,
            ])}
            ref={buttonRef}
            {...props}
        />
    );
}

export default RoundedButton;
